import React from 'react';
import { useEssentials } from '../../contexts/essentials-context';
import { Box, Text } from '@wix/design-system';
import { Badge } from '.';
import s from './badge-tooltip.module.scss';

export interface WixSaleBadgeProps {
  amount: string;
  size?: 'tiny' | 'small' | 'medium';
}
export function WixSaleBadge({ amount, size = 'small' }: WixSaleBadgeProps) {
  amount = Math.round(Number(amount)).toString();
  const { t, experiments } = useEssentials();

  const showNewWixSaleBadge =
    experiments?.enabled('specs.app-market.NewWixSaleBadge') ?? false;

  return (
    <Badge
      skin="neutralSuccess"
      dataHook="wix-sale-badge"
      uppercase={false}
      size={size}
      tooltipContent={
        <Box direction="vertical" gap="6px">
          <Text
            size="small"
            weight="bold"
            // @ts-expect-error wds types are incompatible
            skin="light"
            className={s.tooltipText}
          >
            {t('wix.holiday.sale.badge')}
          </Text>
          <Text
            size="small"
            weight="thin"
            // @ts-expect-error wds types are incompatible
            skin="light"
            className={s.tooltipText}
          >
            {t('wix.sale.badge.tooltip', { amount })}
          </Text>
        </Box>
      }
    >
      <Box fontSize={size === 'medium' ? 'small' : 'tiny'}>
        {showNewWixSaleBadge
          ? t('wix.sale.badge.new', { amount })
          : t('wix.sale.badge', { amount })}
      </Box>
    </Badge>
  );
}
